export class RewardForTournamentPosition{
    public static getReward( position:number ) : number {
        if( position == 0 ){
            return 15;
        }
        if( position == 1 ){
            return 13;
        }
        if( position == 2 ){
            return 12;
        }
        if( position == 3 ){
            return 11;
        }
        if( position < 10 ){
            return 10;
        }
        if( position < 20 ){
            return 9;
        }
        if( position < 30 ){
            return 8;
        }
        if( position < 40 ){
            return 7;
        }
        if( position < 50 ){
            return 6;
        }
        if( position < 60 ){
            return 5;
        }
        if( position < 70 ){
            return 4;
        }
        if( position < 80 ){
            return 3;
        }
        if( position < 90 ){
            return 2;
        }
        if( position < 100 ){
            return 1;
        }
        return 0;
    }
}